import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import {
  MatTableDataSource,
  MatDialog,
  MatPaginator,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material";
import { Router } from "@angular/router";
import { AppService } from "src/_services/app.service";

@Component({
  selector: "app-invoice-management",
  templateUrl: "./invoice-management.component.html",
  styleUrls: ["./invoice-management.component.scss"],
})
export class InvoiceManagementComponent implements OnInit {
  operatorsDisplayedColumns: string[] = [
    "OperatorId",
    "Commission",
    "Wallet",
    "Actions",
  ];
  operators = new MatTableDataSource();
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));

  constructor(
    private appService: AppService,
    private router: Router,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.getOurOperators();
  }

  @ViewChild(MatPaginator) paginator: MatPaginator;
  getOurOperators() {
    try {
      this.appService.getOPCommissionDocs("").subscribe((res) => {
        if (res.status === "RS_OK") {
          // this.operators.data = res.operators;
          this.operators = new MatTableDataSource<any>(res.docs);
          this.operators.paginator = this.paginator;
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  searchOperator(event) {
    const value = event.target.value;
    this.operators.filter = value.trim().toLocaleLowerCase();
  }

  goTo(element) {
    // this.appService.saveOperatorCommission(element)
    let linkRoute = `/invoice/management/iframe`;
    this.router.navigate([linkRoute], {
      queryParams: {
        operatorId: element.operatorId,
      },
    });
  }

  addCommission = () => {
    let dialogRef = this.dialog.open(CreateOperatorCommission, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: { title: "Add Operator Commission", add: true },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getOurOperators();
      }
    });
  };

  editCommission = (element) => {
    let dialogRef = this.dialog.open(CreateOperatorCommission, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: {
        title: "Edit Operator Commission",
        add: false,
        operatorId: element.operatorId,
        commission: element.defaultCommission,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getOurOperators();
      }
    });
  };

  cloneCommission = (element) => {
    let dialogRef = this.dialog.open(CloneCommission, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: {
        title: "Clone Commission",
        operatorId: element.operatorId,
        wallet: element.walletType,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getOurOperators();
      }
    });
  };
}

@Component({
  selector: "dialog-overview-example-dialog",
  templateUrl: "./add-op-commission.html",
  styleUrls: ["./invoice-management.component.scss"],
})
export class CreateOperatorCommission {
  opcommission: FormGroup;
  selected = new FormControl();
  dropdownSettings: any = {};
  operatorData = [];
  constructor(
    private appService: AppService,
    public dialogRef: MatDialogRef<CreateOperatorCommission>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public Data: any
  ) {}

  data = this.Data;
  check = !this.data.add;

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: true,
      idField: "operator_id",
      textField: "operator_id",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    if (this.data.add) {
      this.getOperatorData();
    }

    this.opcommission = new FormGroup({
      operatorId: new FormControl([this.data.operatorId], Validators.required),
      commission: new FormControl(this.data.commission, Validators.required),
    });
  }

  getOperatorData() {
    try {
      this.appService.getOperatorId().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.operatorData = res.operators
            .sort((a, b) => {
              let fa = a.operator_id.toLowerCase(),
                fb = b.operator_id.toLowerCase();

              if (fa < fb) {
                return -1;
              }
              if (fa > fb) {
                return 1;
              }
              return 0;
            })
            .map((operator) => {
              return operator.operator_id;
            });
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  confirm() {
    const payload = {
      operatorId: this.opcommission.value.operatorId[0],
      commission: this.opcommission.value.commission,
    };
    if (this.data.add) {
      try {
        this.appService.createOpCommission(payload).subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar(res.errorDescription);
            this.dialogRef.close(true);
          } else {
            this.appService.openErrorBar(res.errorDescription);
            this.dialogRef.close();
          }
        });
      } catch (err) {}
    } else {
      try {
        this.appService.updateOpCommission(payload).subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar(res.errorDescription);
            this.dialogRef.close(true);
          } else {
            this.appService.openErrorBar(res.errorDescription);
            this.dialogRef.close();
          }
        });
      } catch (err) {}
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: "dialog-overview-example-dialog",
  templateUrl: "./clone-commission.html",
  styleUrls: ["./invoice-management.component.scss"],
})
export class CloneCommission {
  opcommission: FormGroup;
  dropdownSettings: any = {};
  operatorData = [];
  constructor(
    private appService: AppService,
    public dialogRef: MatDialogRef<CloneCommission>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public Data: any
  ) {}

  data = this.Data;
  check = !this.data.add;

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: true,
      idField: "operator_id",
      textField: "operator_id",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.getOperatorData();

    this.opcommission = new FormGroup({
      operatorId: new FormControl(this.data.operatorId, Validators.required),
      selectedOperatorId: new FormControl(
        [this.data.selectedOperatorId],
        Validators.required
      ),
    });
  }

  getOperatorData() {
    try {
      this.appService.getOperatorId().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.operatorData = res.operators
            .sort((a, b) => {
              let fa = a.operator_id.toLowerCase(),
                fb = b.operator_id.toLowerCase();

              if (fa < fb) {
                return -1;
              }
              if (fa > fb) {
                return 1;
              }
              return 0;
            })
            .filter((operator) => {
              if (operator.operator_id === this.data.operatorId) {
                return false;
              }
              if (this.data.wallet === "Feed") {
                return operator.wallet_type === "Feed";
              } else {
                return operator.wallet_type !== "Feed";
              }
            })
            .map((operator) => operator.operator_id);
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  confirm() {
    const payload = {
      baseOperatorId: this.opcommission.value.operatorId,
      operatorId: this.opcommission.value.selectedOperatorId[0],
    };
    try {
      this.appService.cloneCommission(payload).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.appService.openSuccessBar(res.errorDescription);
          this.dialogRef.close(true);
        } else {
          this.appService.openErrorBar(res.errorDescription);
          this.dialogRef.close();
        }
      });
    } catch (err) {}
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
